import React from "react";
import Faqs from "../../views/clientView/faqs";

export default function FaqsPage() {
    return <Faqs />
}